import React from "react";
import ISO6391 from "iso-639-1";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type Props = {
  label?: string;
  value?: string;
  onChange?: (val: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
  triggerClassName?: string;
};

const LanguageSelect: React.FC<Props> = ({
  label,
  value,
  onChange,
  placeholder = "Select language",
  disabled,
  error,
  className,
  triggerClassName,
}) => {
  const languages = React.useMemo(() => {
    const codes = ISO6391.getAllCodes();
    return codes
      .map((code) => ({
        code,
        name: ISO6391.getNativeName(code) || ISO6391.getName(code),
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, []);

  return (
    <div className={className}>
      {label && (
        <label className="text-sm font-medium text-gray-700 uppercase">
          {label}
        </label>
      )}
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          className={`w-full mt-1 ${error ? "border-red-500" : ""} ${triggerClassName || ""}`}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default LanguageSelect;
